import _Date$now from "@babel/runtime-corejs2/core-js/date/now";
import { isString, isFunction } from './try';
var uuid = 0;
export var uniqueId = function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(prefix, "_").concat(++uuid, "_").concat(_Date$now(), "_").concat(Math.floor(Math.random() * 1000000));
};
export var getGlobal = function getGlobal() {
  if (typeof self !== 'undefined') return self;
  if (typeof window !== 'undefined') return window;
  if (typeof global !== 'undefined') return global;
  throw new Error('unable to locate global object');
};
export var globalize = function globalize(handler) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? uniqueId('__globalFunction') : _ref$name,
      _ref$once = _ref.once,
      once = _ref$once === void 0 ? false : _ref$once;

  if (isString(handler)) {
    return handler;
  }

  getGlobal()[name] = function () {
    if (once) delete getGlobal()[name];
    if (isFunction(handler)) return handler.apply(void 0, arguments);
    return;
  };

  return name;
};
globalize.getGlobal = getGlobal; // export default globalize